export { ComponentClass };

import pinLikeSurfaceAction from './utils/pinLikeSurfaceAction';
import { ComponentClass } from 'react';
import { ConversationReadingPaneProps } from './components/ConversationReadingPane';
import { ItemReadingPaneProps } from './components/ItemReadingPane';
import { ReadingPaneProps } from './components/ReadingPane';
import { SecondaryReadingPaneTabCommandingBarProps } from './components/SecondaryReadingPaneTabCommandingBar';
import { createLazyComponent, LazyModule } from 'owa-bundling';
import { lazyGetTrustedSendersAndDomains } from 'owa-trusted-senders';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import { loadSubsriptionsCache } from 'owa-brands-subscription';
import { isFeatureEnabled } from 'owa-feature-flags';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "ReadingPane", webpackPrefetch: true */ './lazyIndex')
);

// Export delay loaded components
export let ConversationReadingPane = createLazyComponent(
    lazyModule,
    m => m.ConversationReadingPane
);

export let ReadingPane = createLazyComponent(lazyModule, m => m.ReadingPane);
export let ItemReadingPane = createLazyComponent(lazyModule, m => m.ItemReadingPane);

export let SecondaryReadingPaneTabCommandingBar = createLazyComponent(
    lazyModule,
    m => m.SecondaryReadingPaneTabCommandingBar
);

runAfterInitialRender(() => {
    if (isFeatureEnabled('rp-infoBarBrandSubscription')) {
        //load Brand Subscriptions cache
        loadSubsriptionsCache();
    }
    lazyGetTrustedSendersAndDomains.importAndExecute;
    pinLikeSurfaceAction();
});

export {
    ConversationReadingPaneProps,
    ItemReadingPaneProps,
    ReadingPaneProps,
    SecondaryReadingPaneTabCommandingBarProps,
};
